import { render, staticRenderFns } from "./FontInput.vue?vue&type=template&id=872abdfc&scoped=true"
import script from "./FontInput.vue?vue&type=script&lang=js"
export * from "./FontInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872abdfc",
  null
  
)

export default component.exports